import React from 'react';

import { SkeletonBlock } from '../../../../components/skeleton/skeleton';

export default function StoreSettingsSkeleton() {
  return (
    <div className="mx-auto max-w-5xl space-y-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex items-start gap-4">
          <SkeletonBlock className="h-16 w-16 shrink-0 rounded-md" />
          <div className="space-y-2">
            <SkeletonBlock className="h-8 w-52 rounded-md" />
            <SkeletonBlock className="h-4 w-full max-w-md rounded" />
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <SkeletonBlock className="h-9 w-32 rounded-full" />
          <SkeletonBlock className="h-9 w-36 rounded-full" />
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {[0, 1, 2, 3, 4, 5, 6].map((i) => (
          <SkeletonBlock key={i} className="h-9 w-24 rounded-full" />
        ))}
      </div>
      <div className="overflow-hidden rounded-md border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800">
        <div className="space-y-4 p-6">
          <SkeletonBlock className="h-6 w-40 rounded" />
          {[0, 1, 2, 3, 4].map((i) => (
            <SkeletonBlock key={i} className="h-4 w-full rounded" />
          ))}
          <SkeletonBlock className="h-4 w-full max-w-md rounded" />
        </div>
      </div>
    </div>
  );
}
